import React, { PureComponent, Fragment } from 'react';
import { formCreator, FormItem, ValidationField, Input, Button, Upload, Modal, RadioGroup, Radio } from 'neatui';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import ajax from "../util/ajax";
import uploadImg from '../../util/uploadImg';
import PhoneValidation from '../../common/phoneValidation';
import UploadButton from './uploadButton';
import { phoneValidator, checkPhone } from '../../util/phoneNumValidator';
import personIdValidator from '../../util/personIdValidator';
import './style.module.scss';

function UploadExample({ ...other }) {
  return (
    <div styleName="upload-example">
      <Upload single {...other} accept="image/png, image/jpeg">
        <UploadButton />
      </Upload>
      <div styleName="add example">
        <img src="//static.ws.126.net/media_dy/imgs/idexp.png" alt="示例" />
      </div>
    </div>
  );
}

const rules = {
  phoneType: {
    validator: value => value !== null,
    message: '请选择手机号类型',
  },
  name: {
    validator: name => name && name.length,
    message: '运营者姓名为必填项',
  },
  idCardNumber: [
    {
      validator: id => personIdValidator(id),
      message: `请填写正确的身份证号码！    账户信息填写需真实有效，如发现虚假以及非个人真实信息导致账号收益无法提现，责任由账号个人承担！`,
    }
  ],
  idScanFront: {
    validator: files => files && files.length,
    message: '请上传身份证正面照片',
  },
  idScanBehind: {
    validator: files => files && files.length,
    message: '请上传身份证反面照片',
  },
  personIdScan: {
    validator: files => files && files.length,
    message: '请上传手持身份证照片',
  },
  mobilePhone: [
    {
      validator: (num, mobilePhone, phoneType) => {
        if (phoneType === 0) return true;
        return phoneValidator(num, mobilePhone)
      },
      message: '请填写正确的手机号码并验证！',
      join: ['mobilePhone', 'phoneType'],
    },
    {
      validator: (num, phoneType) => {
        if (phoneType === 0) return true;
        return checkPhone(num)
      },
      message: '请不要输入虚拟运营商手机号！',
      join: ['phoneType'],
    },
  ],
  captcha: {
    validator: (value, mobilePhone, phoneType) => {
      if (phoneType === 0) return true;
      return ajax(
      '/msg/verify/checkMesgCode.do',
      {
        data: { verifyPhone: mobilePhone, verifyCode: value },
        method: 'POST',
      },
      rs => rs,
      rs => Promise.reject(rs),
      true,
      true,
      )
    },
    join: ['mobilePhone', 'phoneType'],
    message: (value, mobilePhone, validationResult) => {
      if (validationResult) {
        return validationResult.data ? validationResult.data : validationResult.msg
      }
        return '验证码服务出错，请稍后重试'

    },
  },
};
const inputLayout = {
  size: 10,
};
const labelLayout = {
  size: 4,
};

const statusIconLayout = {
  size: 2,
};
const validationLayout = {
  size: 14,
};

class ChangePhoneForm extends PureComponent {
  upload = file => {
    if (!/(gif|png|jpe?g)$/.test(file.type)) {
      Modal.warning({
        title: '提示',
        content: `${file.name || ''}文件类型错误！`,
      });
      return false;
    } if (file.size > 5000000) {
      Modal.warning({
        title: '提示',
        content: `${file.name || ''}文件大于5M！`,
      });
      return false;
    }

    return uploadImg(file, rs => {
      if (rs && rs.code === 1) {
        rs.url = rs.data.ourl;
        return rs;
      }
      return Promise.reject();
    });
  };

  handleSubmit = e => {
    const { submit } = this.props;
    e.preventDefault();
    submit(this.format)();
  };

  format = data => {
    const { common, formValues } = this.props;
    let url = "/admin/customer/updateVerifyTele.do";
    const param = {
      idScanFront: data.idScanFront[0] ? data.idScanFront[0].url : '',
      idScanBehind: data.idScanBehind[0] ? data.idScanBehind[0].url : '',
      personIdScan: data.personIdScan[0] ? data.personIdScan[0].url : '',
      wemediaId: common.user.wemediaId,
      newIdCardNum: data.idCardNumber,
      name: data.name,
      phoneType: data.phoneType
    }

    if (formValues.phoneType === 1) {
      param.telePhone = data.mobilePhone;
    } else {
      url = "/customer/removePhone/Apply.do"
    }

    return ajax(
      url,
      {
        data: param,
        method: 'POST',
      },
      () => {
        Modal.confirm({
          iconType: 'ok-1',
          title: '提交成功',
          vertical: 'middle',
          content: (
            <p>您的手机号正在审核中，请前往"<strong> 帐号信息 </strong>"页查看。</p>
          ),
          size: 'md',
          okText: '确定',
          onOk: () => (location.href = '/subscribe_v3/index.html#/account-settings'),
        });
      },
    );
  };

  render() {
    const { formValues, formErrors, isSubmitting, isValid, isValidating } = this.props;
    const { phoneType } = formValues;
    return (
      <div styleName="page_wrap">
        <form styleName="form" onSubmit={this.handleSubmit}>
          <fieldset styleName="form-set">
            <ValidationField
              styleName="contact-item"
              size="large"
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>手机号类型
              </Fragment>
              }
              helperText=""
              name="phoneType"
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <RadioGroup>
                <Radio label="登录手机号" value={0} key={0} />
                <Radio label="联系手机号" value={1} key={1} />
              </RadioGroup>
            </ValidationField>
            <ValidationField
              styleName="contact-item"
              size="large"
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>运营者姓名
              </Fragment>
              }
              helperText="请填写真实姓名"
              name="name"
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <Input />
            </ValidationField>
            <ValidationField
              styleName="contact-item"
              size="large"
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>运营者身份证
              </Fragment>
              }
              helperText="账户信息填写需真实有效，如发现虚假以及非个人真实信息导致账号收益无法提现，责任由账号个人承担"
              name="idCardNumber"
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <Input />
            </ValidationField>
            <ValidationField
              valuePropName="defaultFiles"
              styleName="upload-item"
              size="large"
              label={
                <Fragment>
                  <span className="red-font">*</span>身份证正面
              </Fragment>
              }
              name="idScanFront"
              helperText="请上传身份证正面图片。png、jpg格式，5M以内"
              statusIconLayout={statusIconLayout}
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <Upload single accept="image/png, image/jpeg" beforeUpload={this.upload}>
                <UploadButton />
              </Upload>
            </ValidationField>
            <ValidationField
              valuePropName="defaultFiles"
              styleName="upload-item"
              size="large"
              label={
                <Fragment>
                  <span className="red-font">*</span>身份证反面
              </Fragment>
              }
              name="idScanBehind"
              helperText="请上传身份证反面图片。png、jpg格式，5M以内"
              statusIconLayout={statusIconLayout}
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <Upload single accept="image/png, image/jpeg" beforeUpload={this.upload}>
                <UploadButton />
              </Upload>
            </ValidationField>
            <ValidationField
              valuePropName="defaultFiles"
              styleName="upload-item"
              size="large"
              label={
                <Fragment>
                  <span className="red-font">*</span>手持身份证半身照
              </Fragment>
              }
              name="personIdScan"
              helperText="手持身份证照片参考示例图，照片中身份证的信息须清晰可见"
              statusIconLayout={statusIconLayout}
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <UploadExample beforeUpload={this.upload} />
            </ValidationField>
            {phoneType === 1 && <ValidationField
              styleName="contact-item"
              size="large"
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>新手机号码
              </Fragment>
              }
              helperText="请输入正确手机号码，并完成校验。校验时如遇弹窗提示'图形验证码验证失败'，请重新输入手机号。"
              name="mobilePhone"
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <Input />
            </ValidationField>}
            {phoneType === 1 && formValues.mobilePhone
              && (formErrors.mobilePhone && formErrors.mobilePhone.length < 1) ? (
                <ValidationField
                  styleName="contact-item"
                  validateTrigger="onBlur"
                  size="large"
                  label=""
                  name="captcha"
                  statusIconLayout={statusIconLayout}
                  inputLayout={validationLayout}
                  labelLayout={labelLayout}>
                  <PhoneValidation verifyPhone={formValues.mobilePhone} key={formValues.mobilePhone} />
                </ValidationField>
              ) : null}
            {phoneType === 0 && <ValidationField
              styleName="contact-item"
              size="large"
              validateTrigger="onBlur"
              label={
                <Fragment>
                  <span className="red-font">*</span>修改类型
              </Fragment>
              }
              helperText=""
              name="changeType"
              inputLayout={inputLayout}
              labelLayout={labelLayout}>
              <span styleName="form-span">解绑手机号</span>
            </ValidationField>}
            <FormItem>
              <Button
                htmlType="submit"
                styleName="submit"
                type="primary"
                disabled={(phoneType === 1 && !(formErrors.captcha && formErrors.captcha.length < 1)) || !isValid || isValidating || isSubmitting}>
                提交
            </Button>
            </FormItem>
          </fieldset>
        </form>
        <div styleName="tips">
          <h4>温馨提示：</h4>
          <ul>
            <li>如原手机号使用正常，请在网易号后台「账号信息」中进行修改。</li>
            <li> 如原手机号无法自行换绑，请提交材料申请换绑。</li>
            <li> 如果提交新手机号已绑定其他网易号，继续提交可能申诉失败，建议使用全新手机号。</li>
          </ul>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    common: state.common,
  }),
  dispatch =>
    bindActionCreators(
      {
        push,
      },
      dispatch,
    ),
)(
  formCreator(
    {
      phoneType: null,
    },
    rules,
  )(ChangePhoneForm),
);
